import React from "react";
import { motion } from "framer-motion";
import { Calendar, Heart, ShieldCheck, Sprout } from "lucide-react";

const items = [
  {
    icon: Calendar,
    value: "Since 2015",
    label: "Caring for mothers",
    hint: "Doctor-led postnatal care, grounded in tradition.",
  },
  {
    icon: Heart,
    value: "100+",
    label: "Mothers cared for",
    hint: "Each one held in a private villa, never as a number.",
  },
  {
    icon: ShieldCheck,
    value: "GMP",
    label: "Certified preparations",
    hint: "Every oil, kashayam and Kizhi made in-house, to standard.",
  },
  {
    icon: Sprout,
    value: "3rd",
    label: "Generation Ayurvedic family",
    hint: "Knowledge passed down, refined for today's mother.",
  },
];

export const TrustStrip = () => {
  return (
    <section
      className="bg-ivory border-y border-sage/15"
      data-testid="trust-strip"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-12 md:py-14">
        <motion.div
          initial={{ opacity: 0, y: 14 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="grid grid-cols-2 lg:grid-cols-4 gap-y-10 gap-x-6 lg:gap-x-2"
        >
          {items.map((it, i) => {
            const Icon = it.icon;
            return (
              <div
                key={it.label}
                className={`flex items-start gap-4 ${
                  i !== 0 ? "lg:pl-8 lg:border-l lg:border-sage/15" : ""
                } ${i % 2 === 1 ? "pl-5 border-l border-sage/15 lg:pl-8" : ""}`}
                data-testid={`trust-item-${i + 1}`}
              >
                <span className="inline-flex items-center justify-center w-11 h-11 rounded-full bg-sage/10 text-sage shrink-0">
                  <Icon size={18} strokeWidth={1.5} />
                </span>
                <div className="min-w-0">
                  <div className="font-serif text-2xl md:text-3xl text-charcoal leading-none">
                    {it.value}
                  </div>
                  <div className="mt-1.5 text-[13px] md:text-sm font-medium text-charcoal">
                    {it.label}
                  </div>
                  <div className="mt-1 text-xs text-charcoal/55 leading-relaxed hidden md:block">
                    {it.hint}
                  </div>
                </div>
              </div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
};

export default TrustStrip;
